import routes from './routes.js'
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import utils from '@/assets/utils'
import notification from '@/components/common/notification'
// import _ from 'lodash'

Vue.use(Router)
const router = new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      if (store.state.config.uiVersion === 2 && from.name !== 'landing') {
      } else {
        setTimeout(() => {
          resolve({selector: '.header-top-scrool'})
        }, 500)
      }
    })
  }
})

router.beforeEach((to, from, next) => {
  // utils.uaEvent('path')
  // check login
  if (to.name !== 'signin' && window.first.isLogin === 'false') {
    router.push({name: 'signin'})
    return
  } else if (to.name === 'signin' && window.first.isLogin === 'ok' && process.env.NODE_ENV !== 'development') {
    router.push({name: 'landing'})
    return
  }

  // update title
  if (to.meta.title) {
    document.title = `SL360 ${to.meta.title}`
  }
  let urls = to.path.split('/')
  // if (urls[1] === 'order' ) {
  if (urls[1] === 'order') {
    if (to.name === 'order' && store.state.config.uiVersion === 2) {
      next()
      return
    }

    // check datasource
    if (!store.getters['config/checkDatasource'](to.params.listType)) {
      next({name: 'landing', query: to.query})
    }

    let listType = parseInt(to.params.listType)
    let datasource = store.state.config.datasource[listType]

    // check geotype
    if (to.name.slice(0, 4) === 'geo-' || urls[3] === undefined || urls[3] === '') {
      if (datasource.geoTabs.indexOf(urls[4]) === -1) {
        router.replace({name: 'geo-' + datasource.geoTabs[0], params: {listType}, replace: true, query: to.query})
        return
      } else {
        store.commit('site/saveKey', ['lastGeoTab', urls[4]])
      }
    }

    // check demotab
    if (to.name.slice(0, 5) === 'demo-') {
      if (store.state.geo.geoUnAdd) {
        let dict = {
          zip: 'ZIP code entered has not been added,  if you would like to use the ZIP as your geographic option please go back',
          radius: 'The radius or ZIP code entered has not been added, if you would like to use the radius or ZIP code as your geographic option please go back'
        }
        notification.notice('info', dict[store.state.geo.geoUnAdd])
        store.commit('geo/saveKey', ['geoUnAdd', false])
      }
      if (to.name === 'demo-multiCount') {
      } else if (datasource.demoTabs.indexOf(urls[4]) === -1) {
        next({name: 'demo-' + datasource.demoTabs[0], params: {listType}, replace: true, query: to.query})
        return
      } else {
        store.commit('site/saveKey', ['lastDemoTab', urls[4]])
      }
    }
  }
  next()
})

router.afterEach((to, from) => {
  utils.uaEvent('path', to.name, from.name)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js